import { render, staticRenderFns } from "./AccountConflict.vue?vue&type=template&id=bba573c8&scoped=true"
import script from "./AccountConflict.vue?vue&type=script&lang=js"
export * from "./AccountConflict.vue?vue&type=script&lang=js"
import style0 from "./AccountConflict.vue?vue&type=style&index=0&id=bba573c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba573c8",
  null
  
)

export default component.exports